import { toast } from "react-toastify";
import { ITypedBaseResponse } from "@nkr/models/base-response";
import { IStrongBoxListing, IStrongBoxFilter, IStrongBoxOrderContract } from "@nkr/models/strong-box";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useRef, useState } from "react";

interface IRetVal {
    list: IStrongBoxListing[],
    loading: boolean,
    error: string,
    placeOrder: (stronBoxOrder: IStrongBoxOrderContract) => void
}

function useStrongBoxCenters(filter?: IStrongBoxFilter): IRetVal {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IStrongBoxListing[]>([]);

    const listRef = useRef<IStrongBoxListing[]>(null);

    useEffect(() => {
        setError('');

        const fetchData = async () => {
            setLoading(true);

            let config = {
                url: `${__API__}/strongbox/search`,
                data: filter
            };

            try {
                const response: ITypedBaseResponse<IStrongBoxListing[]> = await dispatch(AuthActionCreators.apiPost(config));

                if (response && response.data.results && response.data.success) {
                    setList(response.data.results);

                    listRef.current = response.data.results;
                } else {
                    setError('Unable to load data');
                    setList([]);

                    listRef.current = [];
                }
            } catch (err) {
                setList([]);
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        if (filter) fetchData();
    }, [filter]);

    const placeOrder = (strongBoxOrder: IStrongBoxOrderContract) => {
        const postData = async () => {
            setLoading(true);

            let config = {
                url: `${__API__}/strongbox/order`,
                data: strongBoxOrder
            };

            try {
                const response: ITypedBaseResponse<IStrongBoxListing> = await dispatch(AuthActionCreators.apiPost(config));

                if (response && response.data.results && response.data.success) {
                    let updatedList = listRef.current.map(x => {
                        if (x.centerId == response.data.results.centerId) {
                            return response.data.results;
                        }

                        return x;
                    });

                    setList(updatedList);
                } else {
                    toast.error('Unable to place order');
                }
            } catch (err) {
                toast.error(err?.response?.data ? err.response.data : 'Unable to place order');
            } finally {
                setLoading(false);
            }
        }

        postData();
    };

    return { loading, error, list, placeOrder };
}

export default useStrongBoxCenters;